import { facetingAttributePrefix } from '../../../gatsby-build-algolia/constants';

export const FACETING_ATTRIBUTE_PREFIX = facetingAttributePrefix;
